import { supabase } from "./supabase";
import { db } from "./db";
import { removeOutbox } from "./outbox";
import { API, authHeaders } from "./supabase";

export async function deleteJob(d) {
  if (d.queued) { await removeOutbox(d.outbox.idempotency_key); return { refunded: false }; }
  let refunded = false;
  if (d.status === "draft") {
    const { error } = await supabase.from("dispatches").update({ status: "canceled" }).eq("id", d.id);
    if (!error) refunded = true;
  }
  if (d.audio_notes_url) await supabase.storage.from("dispatch-audio").remove([d.audio_notes_url]).catch(() => null);
  if (d.photo_urls?.length) await supabase.storage.from("dispatch-photos").remove(d.photo_urls).catch(() => null);
  if (d.completion_photo_urls?.length) await authHeaders().then((h) => fetch(`${API}/jobs/${d.id}/proof`, { method: "DELETE", headers: h })).catch(() => null);
  const { error } = await supabase.from("dispatches").delete().eq("id", d.id);
  if (error) throw error;
  await db.del("dispatches", d.id);
  return { refunded };
}
